import { Button, Form, Input, message, Typography } from 'antd';
import ResizeWrapper from '@/components/ResizeWrapper';
import styles from './index.module.less';
import React, { useEffect } from 'react';
import { NavBar } from 'antd-mobile';
import { post } from '@/utils/request';
import { useNavigate } from 'react-router-dom';

const { Text, Link } = Typography;

export interface FormProps {
  username: string;
  password: string;
}

export default function() {

  const navigate = useNavigate();
  const [form] = Form.useForm();

  const handleStart = async (formValues: FormProps) => {
    post("/ums/web/auth/reg",{
      credential: formValues.username,
      password: formValues.password,
    }).then((res)=>{
      if(res.code === 200){
        //跳转到首页
        navigate("/login");
      }else{
        message.error(res.msg)
      }
    })
  };

  return (
    <ResizeWrapper className={styles.container}>

      <NavBar
        className={styles.navBar}
        style={{ height: 65 }}
        children={<div className={styles.navBarTitle}>Register</div>}
        onBack={() => {
          history.back();
        }}
      />

      {/*<Header />*/}
      <div className={styles['form-wrapper']} style={{ alignItems: 'flex-start',marginTop: 80}}>
        <div className={styles.main} style={{width: '100%'}}>

          <Form
            form={form}
            layout="vertical"
            onFinish={handleStart}
            style={{width:'80%'}}
          >
            <Form.Item name="username">
              <Input size='large' placeholder="Please enter your username" style={{width:'100%'}}/>
            </Form.Item>
            <Form.Item name="password">
              <Input.Password size='large' placeholder="Please enter your password" style={{width:'100%'}}/>
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                size='middle'
                className={styles.startButton}
              >
                Register
              </Button>
            </Form.Item>

            <div style={{textAlign:'center'}}>
              Don&#39;t have an account?
              <Link href="/login">
                Sign in
              </Link>
            </div>
          </Form>
        </div>
      </div>
    </ResizeWrapper>
  );
}
